import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { postBrandApi, getMenuByIdApi, getsubmenuListApi, getMenuListApi, postMenuApi, changeMenuDisplayApi, updatemenudisplayApi, updateMenuApi } from '../services/Apis';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
export default function useNavigationMenu() {
  const initial_page = useSelector(state => state.globalslice.initial_page);
  const sorting_data = useSelector(state => state.globalslice.sorting_data);

  const navigate = useNavigate()
  const queryClient = useQueryClient();

  const getMenu = (perPage) => {
    return useQuery({
      queryKey: ['menu_list', { 'page': initial_page, limit: perPage, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }],
      queryFn: () => getMenuListApi({ 'page': initial_page, limit: perPage, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: 0,
    });
  }

  const getSubMenu = (id,perPage) => {
    return useQuery({
      queryKey: ['submenu_list', { menuid: id, 'page': initial_page, limit: perPage, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }],
      queryFn: () => getsubmenuListApi({ menuid: id, 'page': initial_page, limit: perPage, sort: sorting_data.sortBy, order: sorting_data.sortOrder, search: sorting_data.search }),
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  }

  const postMenu = useMutation({
    mutationFn: (formData) => {
      if (formData.id) {
        return updateMenuApi(formData);  // if id exists — update
      } else {
        return postMenuApi(formData);    // else — create
      }
    },
    onSuccess: (data) => {
      toast.success('Menu updated successfully',100)
      // queryClient.invalidateQueries({ queryKey: ['submenuById', { id: data.data }] });
      if (data.data == 0) {
        queryClient.getQueryCache().findAll().forEach((query) => {
          if (query.queryKey[0] === 'menu_list' || query.queryKey[0] === 'submenuById' || query.queryKey[0] === 'menu-access') {
            queryClient.removeQueries({ queryKey: query.queryKey });
          }
        });
        navigate(`/admin/menu`)
      } else {
        queryClient.getQueryCache().findAll().forEach((query) => {
          if (query.queryKey[0] === 'submenu_list' || query.queryKey[0] === 'submenuById' || query.queryKey[0] === 'menu-access') {
            queryClient.removeQueries({ queryKey: query.queryKey });
          }
        });
        navigate(`/admin/menu/submenu/${data.data}`)
      }
    },
    onError: (error) => {
      console.error('Login failed', error);
    },
  });

  const changeMenuDisplay = useMutation({
    mutationFn: (formData) => {
      return changeMenuDisplayApi(formData)
    },
    onSuccess: (data) => {
      queryClient.getQueryCache().findAll().forEach((query) => {
        if (query.queryKey[0] === 'menu_list' || query.queryKey[0] === 'submenuById') {
          queryClient.removeQueries({ queryKey: query.queryKey });
        }
      });
    },
    onError: (error) => {
      console.error('Login failed', error);
    },
  });

  const updatemenudisplay = useMutation({
    mutationFn: (formData) => {
     return updatemenudisplayApi(formData)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'menu_list'
      });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'submenu_list'
      });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'menu-access'
      });
    },
    onError: (error) => {
      console.error('Login failed', error);
    },
  });

  const getSubMenuById = (id) => {
    return useQuery({
      queryKey: ['submenuById', { 'id': id }],
      queryFn: () => getMenuByIdApi(id),
      enabled: !!id,   // <--- only run if id (slug) exists
      cacheTime: Infinity,
      refetchOnMount: false,
      staleTime: Infinity,
    });
  }


  return {
    getMenu: getMenu,
    getSubMenu: getSubMenu,
    postMenu: postMenu,
    updatemenudisplay: updatemenudisplay,
    changeMenuDisplay: changeMenuDisplay,
    getSubMenuById: getSubMenuById
  };
};
